import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import ReactPlayer from 'react-player';
import { handleDownloadVideoTourFromGcs } from '../../services/gcs';
import { urlParam } from '../../utils/url-param';
import theme from '../../config/theme';
import { videoTourExistsSet } from '../../store/car-slice';
import { useDispatch } from 'react-redux';

export default function VideoTour() {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(true);
  const [videoUrl, setVideoUrl] = React.useState('');
  const pid = urlParam('pid');
  const uid = urlParam('uid');

  React.useEffect(() => {
    if (pid && uid) {
      handleDownloadVideoTourFromGcs(uid, pid)
        .then((url: any) => {
          setVideoUrl(url);
        })
        .catch((e) => console.log(e));
    }
  }, []);

  if (!videoUrl) {
    dispatch(videoTourExistsSet(false));
    return null;
  } else {
    dispatch(videoTourExistsSet(true));
  }

  return (
    <Box
      id="video-tour-container"
      sx={{
        py: 10,
        width: '65%',
        margin: '0 auto',

        [theme.breakpoints.down('lg')]: {
          width: '75%',
          py: 5,
        },
        [theme.breakpoints.down('md')]: {
          width: '95%',
        },
      }}
    >
      <Typography align="center" mb={2} variant="h4">
        Video Tour
      </Typography>
      <Skeleton
        sx={{
          display: loading ? 'block' : 'none',
          borderRadius: 5,
          boxShadow: '0 0 9px -2px #454545',
          background: '#8d8d8d',
          objectFit: 'cover',
          transition: 'translate 300ms ease-in-out',
          transform: 'none',
          height: '75dvh',
          [theme.breakpoints.down('xl')]: {
            height: '50dvh',
          },
          [theme.breakpoints.down('lg')]: {
            height: '40dvh',
          },
          [theme.breakpoints.down('md')]: {
            height: '30dvh',
          },
        }}
      />

      <ReactPlayer
        config={{
          file: {
            attributes: {
              preload: 'metadata',
              onLoadedMetadata: () => setLoading(false),
              onload: () => setLoading(false),
            },
          },
        }}
        controls
        height="100%"
        onReady={() => {
          setLoading(false);
        }}
        progressInterval={1000}
        style={{ display: loading ? 'none' : 'block', borderRadius: '1rem' }}
        url={videoUrl}
        width="100%"
      />
    </Box>
  );
}
